/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_12_TitleInputs */

const en_terms_section_12_title = /** @type {(inputs: Terms_Section_12_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Contact`)
};

const lv_terms_section_12_title = /** @type {(inputs: Terms_Section_12_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Kontakti`)
};

/**
* | output |
* | --- |
* | "12. Contact" |
*
* @param {Terms_Section_12_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_12_title = /** @type {((inputs?: Terms_Section_12_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_12_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_12_title(inputs)
	return en_terms_section_12_title(inputs)
});